import { useCallback } from 'react';

import { IRestaurant } from '@rbi-ctg/store';
import { usePosDataQuery } from 'state/store/hooks/use-pos-data-query';

type UseStoreLocatorPrefetchHook = () => {
  prefetchRestaurantValuesForOrder: (restaurant: IRestaurant) => void;
};

export const useStoreLocatorPrefetch: UseStoreLocatorPrefetchHook = () => {
  const { refetch: getPosData } = usePosDataQuery({
    lazy: true,
    restaurantPosDataId: '',
    storeNumber: '',
  });

  const prefetchRestaurantValuesForOrder = useCallback(
    (restaurant: IRestaurant) => {
      getPosData({
        restaurantPosDataId: restaurant.restaurantPosData?._id || '',
        storeNumber: restaurant.number || null,
      });
    },
    [getPosData]
  );

  return {
    prefetchRestaurantValuesForOrder,
  };
};
